import {ApiClient} from '@hconnect/apiclient'
import {useUpmPlantContext} from '@hconnect/upm'
import {useQuery} from '@tanstack/react-query'

export enum PlannerFeature {
  PlanningComments = 'planning_comments',
  OperatorViewExactElectricityPrices = 'operator_view_exact_electricity_prices',
  OperatorViewColorCodedElectricityPrices = 'operator_view_color_coded_electricity_prices'
}

interface PlantConfigData {
  available_features: string[]
}

const PLANT_CONFIG_QUERY_KEY = 'plantConfig'

export const usePlantConfigQuery = () => {
  const {plantId} = useUpmPlantContext()
  return useQuery<PlantConfigData>({
    queryKey: [PLANT_CONFIG_QUERY_KEY, plantId],
    queryFn: async () => {
      const path = `/hcem/ui/v2/config/${plantId}`
      const response = await ApiClient.axiosInstance.get<PlantConfigData>(path)
      return response.data
    },
    enabled: Boolean(plantId)
  })
}

/**
 * @deprecated Remove after planner features are exported to config cat
 */
export const usePlannerFeature = (feature: PlannerFeature) => {
  const {data: plantConfig} = usePlantConfigQuery()
  const availableFeatures = plantConfig?.available_features || []
  return availableFeatures.includes(feature)
}
